import {
    CGF300Code,
    CGF350Code,
    CGF400Code,
    CGS200Code,
    KompasDblCode,
    KompasSglCode,
    RomanoCode,
} from ".";

export const RollerSetTypeCode = "dr-roller";
export const PatchesSetTypeCode = "dr-patches";
export const UHolderTypeCode = "dr-uholder";
export const HandleTypeCode = "dr-handle";
export const LockTypeCode = "dr-lock";
export const SingleFabricProducedDoorTypeCode = "dr-door-kmp-s";
export const DoubleFabricProducedDoorTypeCode = "dr-door-kmp-d";

export const TransomHardwareTypeCode = "tr-hwset";

export const TransomPivotPatchPSPValueCode = "tr-hwset-st";
export const MountedTransomPatchPSCValueCode = "tr-hwset-sm";
export const CutsHolesTransomValueCode = "tr-hwset-ct";

export const CutsHolesTypeCode = "holes-01";
export const HardwareNoneTypeCode = "none";

export const LockTitle = "Lock";
export const HandleTitle = "Handle";
export const PatchesSetTitle = "Patches set";

export const SteelPatchesSetTypeCode = "patch-steel";
export const PatchesSetBulletHingesCode = "patch-steel-bullet";
export const PatchesSetConcealedHingesCode = "patch-steel-concealed";

export const ExtraLength24 = "hnd-ls-1";
export const ModenaLeverBlack = "hnd-ml";
export const MinimalPullHandle = "hnd-mp";
export const NovaConcealedHandle = "hnd-nc";
export const LeverHandle = "hnd-lh";

export const defaultsHardwareStructureCode = {
    [CGS200Code]: ExtraLength24,
    [CGF300Code]: ExtraLength24,
    [CGF350Code]: ExtraLength24,
    [CGF400Code]: ExtraLength24,
    [KompasDblCode]: ExtraLength24,
    [KompasSglCode]: ExtraLength24,
    [RomanoCode]: ExtraLength24,
};
